import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SpinnerCircles from '../../../Spinner/SpinerCircles';
import { formatE911AddressLines, sanitizeE911Field } from './e911Utils';
import '../../../addressValidation.css';

const E911ConfirmDeviceModal = ({
  isOpen,
  number,
  address,
  saving,
  readOnly,
  allowSkip = true,
  onConfirm,
  onChange,
  onSkip,
  onCancel,
}) => {
  const lines = formatE911AddressLines(address);
  const hasCallerName = !!sanitizeE911Field(address?.callername);

  return (
    <Modal
      isOpen={isOpen}
      centered
      backdrop="static"
      keyboard={false}
      zIndex={2000}
      modalClassName="e911-confirm-modal"
    >
      <ModalHeader toggle={onCancel}>
        <div className="e911-confirm-header">
          <FontAwesomeIcon
            icon="map-marker-alt"
            className="e911-confirm-header-icon"
            size="lg"
            color="#fff"
          />
          <div>
            <h2 className="e911-confirm-title">Confirm E911 Address</h2>
            <p className="e911-confirm-number">Number: {number || ''}</p>
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="e911-confirm-info">
          <FontAwesomeIcon icon="exclamation-circle" className="e911-confirm-info-icon" />
          <span>
            We pre-filled the E911 address from this device&apos;s registered location. Please
            confirm it&apos;s correct for emergency dispatch, or update it below.
          </span>
        </div>
        <div className="e911-prefilled-location">
          <div className="e911-confirm-label">Device Location (Pre-filled)</div>
          <p className="e911-confirm-address">
            {lines.map((line, index) => (
              <span
                key={`${line}-${index}`}
                className={index === 0 && hasCallerName ? 'e911-confirm-address-name' : undefined}
              >
                {line}
                {index < lines.length - 1 ? <br /> : null}
              </span>
            ))}
          </p>
          <button
            type="button"
            className="e911-confirm-update-link"
            onClick={onChange}
            disabled={saving}
          >
            This is wrong — let me update it
          </button>
        </div>
      </ModalBody>
      <ModalFooter>
        {allowSkip ? (
          <Button
            outline
            color="secondary"
            className="e911-confirm-skip-btn"
            onClick={onSkip}
            disabled={saving}
          >
            Skip for Now
          </Button>
        ) : (
          <Button
            outline
            color="secondary"
            className="e911-confirm-skip-btn"
            onClick={onCancel}
            disabled={saving}
          >
            Cancel
          </Button>
        )}
        <Button
          color="primary"
          className="e911-confirm-primary-btn"
          onClick={onConfirm}
          disabled={saving || readOnly}
        >
          {saving ? (
            <SpinnerCircles />
          ) : (
            <>
              <FontAwesomeIcon icon="check-circle" />
              Confirm E911 Address
            </>
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default E911ConfirmDeviceModal;
